import { AxiosError } from 'axios';

const parseMessage = (exceptionData: { code: string; message?: string }) => {
  if (!exceptionData) {
    return undefined;
  }

  return `${exceptionData.code} - ${exceptionData.message}`;
};

const isNetworkError = (error: Error) => error?.stack?.startsWith('Error: Network Error');

const isAuthorizationError = (error: AxiosError) =>
  error?.config?.url && error.config.url.indexOf('authorization') > -1;

export const formatAxiosError = (error: AxiosError, actionMessage = '') => {
  if (process.env.NODE_ENV === 'development') {
    console.error(actionMessage, error); // eslint-disable-line no-console
  }

  let formattedMessage = actionMessage;
  if (isNetworkError(error)) {
    formattedMessage = 'A network error has occured. Please check your internet connection.';
  } else if (isAuthorizationError(error)) {
    formattedMessage = 'An error has occured while authorizing.';
    if (error.response) {
      if (error.response.status === 400) {
        formattedMessage += ' Incorrect client id or client secret.';
      } else if (error.response.status === 404) {
        formattedMessage += ' Invalid API endpoint.';
      }
    }
  } else {
    const apiMessage = parseMessage(error.response?.data?.error);
    const details = error.response?.data?.error?.details[0]?.message;
    if (apiMessage) {
      formattedMessage += `\n${apiMessage}`;
    }

    if (details !== undefined) {
      formattedMessage += ' ';
      formattedMessage += details;
    }
  }

  error.message = formattedMessage; // eslint-disable-line no-param-reassign
  return error;
};

export default formatAxiosError;
